<template>
  <div>
    <div v-if="authenticated && hasViewActivityLogPermission">
      <div class="activity-log-select-container t-container">
        <v-select
          class="activity-log-select"
          v-model="usersSearch"
          :items="users"
          label="Users"
          multiple
          clearable
          solo
          chips
          deletable-chips
        ></v-select>

        <v-select
          class="activity-log-select"
          v-model="actionsSearch"
          :items="actions"
          label="Actions"
          multiple
          clearable
          solo
          chips
          deletable-chips
        ></v-select>
      </div>
      <v-card-title>
        <span class="al-title">Activity Log</span>
        <v-spacer></v-spacer>
        <v-btn
          v-if="hasExportActivityLogPermission"
          @click="exportActivityLog()"
          icon
          color="green"
        >
          <v-icon>fas fa-file-export</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Quick Search"
          single-line
          hide-details
        ></v-text-field>
        <v-btn v-if="hasViewActivityLogPermission" @click="advancedSearch" text>
          Advanced Search
        </v-btn>
      </v-card-title>
      <div class="t-container ">
        <v-data-table
          :headers="headers"
          :item-class="rowClass"
          :items="displayed"
          :search="search"
          :loading="loading"
          @pagination="tablePagination = $event"
        >
          <template v-slot:item.operationType="{ item }">
            {{ operationTypeText(item.operationType) }}
          </template>

          <template v-slot:loading>
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
        </v-data-table>
      </div>
    </div>
    <ActivityLogSearchModal
      :dialog="searchDialog"
      v-model="searchModel"
      :operationTypesProp="operationTypes"
      @search="searchEvent"
      @reset="resetSearch"
      @close="closeSearchDialog"
    />
  </div>
</template>
<style>
.activity-log-select-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.v-input__slot {
  margin: 0;
}
.al-title {
  font-size: 2rem;
}
</style>
<script>
import ActivityLogPermissionsMixin from "@/components/activitylog/ActivityLogPermissionsMixin.js";
import ActivityLogSearchMixin from "@/components/activitylog/ActivityLogSearchMixin.js";
import ActivityLogSearchModal from "@/components/widgets/ActivityLogSearchModal.vue";
import TablePaginationMixin from "@/components/widgets/TablePaginationMixin.js";
import Report from "@/services/Report.js";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";

export default {
  mixins: [
    ActivityLogPermissionsMixin,
    ActivityLogSearchMixin,
    TablePaginationMixin("loadMoreActivities")
  ],
  components: {
    ActivityLogSearchModal
  },
  data: () => {
    return {
      usersSearch: [],
      actionsSearch: [],
      reportFileName: "ActivityLog.csv",
      headers: [
        {
          text: "Date",
          value: "actionDate",
          align: "center"
        },
        { text: "Name", value: "userName", align: "center" },
        { text: "Email", value: "userEmail", align: "center" },
        { text: "Action", value: "operationType", align: "center" },
        { text: "Details", value: "detail", align: "center" }
      ],
      searchDialog: false
    };
  },
  beforeMount: function() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "ActivityLog" }]);
    const email = this.$route.params.email;
    if (!!email) {
      this.searchModel.userEmail = email;
    }
    this.searchEvent().catch(error => {
      this.$logger.error(error);
    });
  },
  computed: {
    searchfields() {
      return this.usersSearch.concat(this.actionsSearch);
    },
    users() {
      return this.activities.map(activity => {
        return activity.userEmail;
      });
    },
    actions() {
      return this.activities.map(activity => {
        return activity.operationType;
      });
    },
    displayed() {
      return this.filter();
    }
  },
  methods: {
    rowClass() {
      const rowClass = "table-rows";
      return rowClass;
    },
    advancedSearch() {
      this.searchDialog = true;
    },
    closeSearchDialog() {
      this.searchDialog = false;
    },
    operationTypeText(operationType) {
      if (!operationType) return "";
      return !!this.operationTypes[operationType]
        ? this.operationTypes[operationType].text
        : operationType;
    },
    filter() {
      var vm = this;

      return this.activities.filter(function(act) {
        return (
          (vm.usersSearch.length == 0 ||
            vm.usersSearch.includes(act.userEmail)) &&
          (vm.actionsSearch.length == 0 ||
            vm.actionsSearch.includes(act.operationType))
        );
      });
    },
    exportActivityLog() {
      if (!this.hasExportActivityLogPermission) return;
      let csv = Report.jsonToCSV(this.activities);
      Report.fileDownload(this.reportFileName, csv, "text/csv;charset=utf-8;");
    }
  }
};
</script>
